/**
 * Returns array value with the largest value of the iteratee property. Supports string iteratee only.
 * @param collection
 * @param iteratee
 * @returns
 */
function maxBy(collection, iteratee) {
    return collection
        ? collection.reduce(function (a, b) {
            return a[iteratee] > b[iteratee] ? a : b;
        }, {})
        : undefined;
}
export default maxBy;
